import { tv } from '~/utils/tv'

const tooltipStyles = tv({
  slots: {
    content: [
      // container
      'tooltip-shadow w-fit min-w-[var(--sizing-huge)] max-w-[22.5rem] bg-[var(--color-fill-neutral-default)] p-[var(--padding-inset-fourpulse)]',
      // border
      'rounded-[var(--border-radius-largecontainer)] border-[length:var(--border-width-quarterpulse)] border-[var(--color-border-neutral-default)]',
      // text
      'text-[length:var(--font-size-threepulse)] text-[var(--color-text-neutral-default)] leading-[var(--line-height-medium)]',
      // states
      'data-[state=open]:fade-in data-[state=closed]:fade-out data-[state=closed]:animate-out data-[state=open]:animate-in',
    ],
  },
})

export const { content } = tooltipStyles()
